import React, { Component } from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import PropTypes from 'prop-types';
import { PersistGate } from 'redux-persist/integration/react';
import history from '../history';
import { Routes } from '../routes';

class Root extends Component {
	render() {
		const { store, locale, lang, persistor } = this.props;
		return (
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<ConfigProvider locale={locale[lang].language}>
						<IntlProvider locale={locale[lang].intl} messages={locale[lang].messages}>
							<Router history={history}>
								<Routes />
							</Router>
						</IntlProvider>
					</ConfigProvider>
				</PersistGate>
			</Provider>
		);
	}
}

Root.propTypes = {
	store: PropTypes.object.isRequired,
	locale: PropTypes.object.isRequired,
	lang: PropTypes.string.isRequired,
	persistor: PropTypes.object.isRequired,
};

export default Root;
